var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('omint-page',[_c('Header',{attrs:{"name":"Busca de rede","titleLabel":"Busca de rede"}}),_c('omint-slider',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }